import * as React from 'react'
import { FormControl, IconButton } from '@mui/material'
import { OutlinedInput as MUIOutlinedInput } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'
import { IMaskInput } from 'react-imask'

import { Eye, EyeOff } from 'lucide-react'

import * as styles from './OutlinedInput.module.scss'

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, name, ...other } = props
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={value => onChange({ target: { name, value } })}
      overwrite
    />
  )
})

export const OutlinedInput = ({
  name,
  register,
  label,
  inputType,
  error,
  required,
  disabled,
  fieldStyle,
  containerStyle,
}) => {
  const [type, setType] = React.useState(inputType)
  const { ref, onChange, ...restRegister } = register(name, { required })

  const handleClickShowPassword = () => {
    setType(type === 'password' ? 'text' : 'password')
  }

  const endAdornment =
    inputType === 'password' ? (
      <IconButton
        aria-label="toggle password visibility"
        onClick={handleClickShowPassword}
        edge="end"
        size="small"
      >
        {type === 'password' ? <Eye /> : <EyeOff />}
      </IconButton>
    ) : null

  return (
    <FormControl fullWidth sx={containerStyle}>
      <InputLabel
        shrink
        variant="outlined"
        required={required}
        htmlFor={name}
        classes={{
          focused: !error ? styles.labelFocused : styles.labelFocusedError,
          asterisk: styles.asterisk,
        }}
      >
        {label}
      </InputLabel>
      {inputType === 'phoneNumber' ? (
        <MUIOutlinedInput
          required={required}
          inputComponent={TextMaskCustom}
          inputProps={{
            ref: ref,
            name: name,
            onChange: onChange,
            ...restRegister,
          }}
          classes={{
            focused: !error && styles.focusTest,
            notchedOutline: styles.notchedOutline,
          }}
          label={label}
          notched
          id={name}
          aria-describedby={name}
          error={!!error}
          disabled={disabled}
          sx={fieldStyle}
        />
      ) : (
        <MUIOutlinedInput
          required={required}
          {...register(name, { required: required })}
          type={type}
          classes={{
            focused: !error && styles.focusTest,
            notchedOutline: styles.notchedOutline,
          }}
          label={label}
          notched
          id={name}
          aria-describedby={name}
          error={!!error}
          disabled={disabled}
          endAdornment={endAdornment}
          sx={fieldStyle}
        />
      )}
      {error && (
        <FormHelperText sx={{ fontSize: '0.75rem' }} error={!!error} id={name}>
          {error && error.message}
        </FormHelperText>
      )}
    </FormControl>
  )
}
